import { inject, Pipe, PipeTransform } from '@angular/core';
import { PercentageUtilitiesService } from '@utilities/percentage-utilities.service';

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  private readonly percentageUtilitiesService = inject(PercentageUtilitiesService);

  public transform(value: number | null | undefined, fromFloat = false, decimalPlaces = 2): string {
    return this.percentageUtilitiesService.getPercentage(value, fromFloat, decimalPlaces);
  }
}
